import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ROLES } from 'config';
import { PATH_DASHBOARD } from 'routers/paths';
import { RoleRouter } from 'routers/RoleRouter';

const Brands = lazy(() => import('pages/shop/Brands'));
const AllProducts = lazy(() => import('pages/shop/AllProducts'));
const Colors = lazy(() => import('pages/shop/Colors'));
const Vendors = lazy(() => import('pages/shop/Vendors'));
const OrdersYFC = lazy(() => import('pages/shop/OrdersYFC'));
const OrdersVendor = lazy(() => import('pages/shop/OrdersVendor'));
const VoucherSOrder = lazy(() => import('pages/shop/VoucherOrder'));

const NotFound = lazy(() => import('pages/Page404'));

export default function Shop() {
  return (
    <Routes>
      <Route
        path={`${PATH_DASHBOARD.brands.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.VENDOR_ADMIN, ROLES.SUPER_ADMIN]}>
            <Brands />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.colors.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.VENDOR_ADMIN, ROLES.SUPER_ADMIN]}>
            <Colors />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.allProducts.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.SUPER_ADMIN]}>
            <AllProducts />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.vendors.root}/*`}
        element={
          <RoleRouter
            permittedRole={[ROLES.YFC_ADMIN, ROLES.VENDOR_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}
          >
            <Vendors />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.ordersVendor.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.VENDOR_ADMIN]}>
            <OrdersVendor />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.ordersYFC.root}/*`}
        element={
          <RoleRouter permittedRole={[ROLES.YFC_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}>
            <OrdersYFC />
          </RoleRouter>
        }
      />
      <Route
        path={`${PATH_DASHBOARD.voucherOrder.root}/*`}
        element={
          <RoleRouter
            permittedRole={[ROLES.YFC_ADMIN, ROLES.VENDOR_ADMIN, ROLES.FRANCHISE_REGION_ADMIN, ROLES.SUPER_ADMIN]}
          >
            <VoucherSOrder />
          </RoleRouter>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
